<template>
  <v-simple-table style="background-color: #fff !important;">
    <template v-slot:default>
      <thead>
      <tr>
        <th class="text-left">Trimestre</th>
        <th class="text-left">Subtotal</th>
        <th class="text-left">IRPF</th>
        <th class="text-left">IVA</th>
        <th class="text-left">Total</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>1er Timestre</td>
        <td>{{ getParseTotal(first.subtotal) }}€</td>
        <td>{{ getParseTotal(first.irpf) }}€</td>
        <td>{{ getParseTotal(first.IVA) }}€</td>
        <td>{{ getParseTotal(first.total) }}€</td>
      </tr>
      <tr>
        <td>2º Timestre</td>
        <td>{{ getParseTotal(second.subtotal) }}€</td>
        <td>{{ getParseTotal(second.irpf) }}€</td>
        <td>{{ getParseTotal(second.IVA) }}€</td>
        <td>{{ getParseTotal(second.total) }}€</td>
      </tr>
      <tr>
        <td>3er Timestre</td>
        <td>{{ getParseTotal(third.subtotal) }}€</td>
        <td>{{ getParseTotal(third.irpf) }}€</td>
        <td>{{ getParseTotal(third.IVA) }}€</td>
        <td>{{ getParseTotal(third.total) }}€</td>
      </tr>
      <tr>
        <td>4º Timestre</td>
        <td>{{ getParseTotal(fourth.subtotal) }}€</td>
        <td>{{ getParseTotal(fourth.irpf) }}€</td>
        <td>{{ getParseTotal(fourth.IVA) }}€</td>
        <td>{{ getParseTotal(fourth.total) }}€</td>
      </tr>
      <tr>
        <td>Total año</td>

        <td>{{ getParseTotal(total.total) }}€</td>
        <td>{{ getParseTotal(total.irpf) }}€</td>
        <td>{{ getParseTotal(total.IVA) }}€</td>
        <td>--</td>
      </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
export default {
  name: "budgetsTable",
  props: ['first', 'second', 'third', 'fourth', 'total'],
  methods:{
    getParseTotal(total) {
      return parseFloat(total).toFixed(2)
    },
  }
}
</script>

<style scoped>

</style>